import * as Aes from 'crypto-js/aes';
import * as CryptoJsCore from 'crypto-js/core';

// NOTE: We use crypto-js following the implementation of https://github.com/maxdeviant/redux-persist-transform-encrypt

export function encryptString(plainText: string, secretKey: string) {
  return Aes.encrypt(plainText, secretKey).toString();
}

export function decryptString(encryptedText: string, secretKey: string) {
  return Aes.decrypt(encryptedText, secretKey).toString(CryptoJsCore.enc.Utf8);
}
